import { Fragment, useState } from 'react';
import { Trans } from '@lingui/macro';
import { Button } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { CreateKeyForm } from 'app/domains/api-management';
export function CreateApiKeyButton(props) {
    const { appearance, icon = true } = props;
    const [showForm, setShowForm] = useState(false);
    return (<Fragment>
      <Button type="button" appearance={appearance} onClick={() => setShowForm(true)}>
        {icon && <Falcon icon="plus"/>}
        <Trans comment="Create api key button label">Create key</Trans>
      </Button>

      {showForm && <CreateKeyForm onClose={() => setShowForm(false)}/>}
    </Fragment>);
}
